module.exports = __webpack_public_path__ + "img/graph_bar_icon.0e7606d1.svg";